import React from 'react';
import { BrowserRouter as Router, Route, Switch } from "react-router-dom";
import {
  AppLayout
} from "AWS-UI-Components-React";

import Navigation from "./components/Navigation.jsx";
import Breadcrumbs from "./components/Breadcrumbs.jsx";
import Dashboard from "./components/Dashboard.jsx";
import CreateTestCase from "./components/CreateTestCase.jsx";

import "./styles/header.css";

const RouterSwitchContent = () => (
  <Switch>
    <Route exact path="/" component={CreateTestCase} />
    <Route exact path="/create-test-case" component={CreateTestCase} />
    <Route exact path="/search-test-cases" component={Dashboard} />
  </Switch>
);

const App = () => {
  return (
    <div id="b">
      <ul id="h" className="menu-list">
        <li className="selected"><a href="/">POC TaaS</a></li>
      </ul>
      <div >
        <Router>
          <AppLayout
            className='awsui-util'
            content={<RouterSwitchContent />}
            navigation={<Navigation />}
            toolsHide={true}
            breadcrumbs={<Breadcrumbs />}
          />
        </Router>
      </div>
    </div>
  );
};

export default App;


// WEBPACK FOOTER //
// ./src/App.jsx